import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService} from './auth.service';
import { ProjectConfigurationService} from '../global_services/project_config.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

   constructor(private projectConfigurationService: ProjectConfigurationService, private authService: AuthService, private router: Router) {}
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    let url: string = state.url;

    var client = url.split("/");
    console.log('AuthGuard#canActivate called', url);

    return this.checkLogin(url, client[1]);

  }


  checkLogin(url: string, client? ): boolean {
    if (this.authService.isLoggedIn()) { 
      return true; 
    }

    // Store the attempted URL for redirecting
    // this.authService.redirectUrl = url;

    let redirect = ('/' + client + '/login');

    console.log("AuthGuard. Redirecting to ", redirect)

    // Navigate to the login page with extras
    this.router.navigate([redirect, {redirect: url}]);
    return false;
  }


}